import { Event } from "../../../../Global/Base/Events";
import { IDisposable } from "../../../../Global/Base/IDisposable";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { UIManager } from "../UIManager";
import { FormResult, FormResultType } from "./Forms/FormResult";
import { IShowModalParams, IWindowableWithIFRMParams, ModalWindowType } from "./ModalWindowInterfaces";

export class ModalWindow implements IDisposable {
    //#region Events
    public readonly close: Event<ModalWindow, void> = new Event<ModalWindow, void>();
    /** Událost zavření okna */
    public readonly onClose: Event<ModalWindow, void> = new Event<ModalWindow, void>();
    //#endregion Events
    public readonly onDispose: Event<ModalWindow, void> = new Event<ModalWindow, void>();

    public readonly window: IWindowableWithIFRMParams;
    //#region Fields
    public container: HTMLDivElement;
    // @ts-ignore // nevyužito, ale ponecháno
    private _maximized: boolean;
    //#endregion Fields

    //#region Constructors
    constructor(config: IShowModalParams) {
        this.container = createElement({ classes: [ "ModalWindow", ModalWindowType[config.type] ], id: UIManager.instance.generateElementID() }) as HTMLDivElement;
        this.window = config.window;

        config.window.closed.add((sender, e) => {
            if (config.onClose) {
                config.onClose(sender, e);
            }

            this.onClose.trigger(this, null);

            this.dispose();
        });

        const fmenu = document.getElementById("formsMenu");
        if (fmenu)
            this.container.style.left = (fmenu.clientWidth) + "px";
        else
            this.container.style.left = "0";

        //Inicializace Headeru
        if (config && config.modalConfig.showHeader) {
            const modalWindowHeader: ModalWindowHeader = new ModalWindowHeader(config.window.titleLocKey, config.modalConfig.closeAble, config.modalConfig.resizeable);
            if (config.modalConfig.closeAble !== undefined && config.modalConfig.closeAble !== null && config.modalConfig.closeAble == true) {
                if (!config.onClose) {
                    config.onClose = () => {
                        $(this.container).slideUp();
                        self.setTimeout(() => {
                            this.container.remove();
                        }, 400);
                    };
                }
                modalWindowHeader.close.add((_sender, value) => {
                    if (config.onClose) {
                        config.onClose(config.window, new FormResult(value, FormResultType.cancel));
                    }

                    this.onClose.trigger(this, null);

                    if (document.getElementsByClassName("ModalWindow").length == 1)
                        UIManager.instance.showOverlay(false);
                });
            }
            if (config.modalConfig.resizeable == true) {
                modalWindowHeader.minimize.add((_sender, _value) => {
                    this._maximized = false;
                    this.container.classList.remove("Minimize");
                    this.container.classList.add("Maximize");
                });
                modalWindowHeader.maximize.add((_sender, _value) => {
                    this._maximized = true;
                    this.container.classList.remove("Maximize");
                    this.container.classList.add("Minimize");
                });
            }
            this.container.appendChild(modalWindowHeader.container);
        }

        this.container.appendChild(config.window.getElement());
        let headAndFootHeight: number = 0; //vyska hlavicky a paticky
        if (config) {
            //if (config.showHeader)
            //    headAndFootHeight += 30;
            if (config.modalConfig.showFooter)
                headAndFootHeight += 30;
        }
        config.window.getElement().style.height = "calc(100% - " + headAndFootHeight + "px)";
        //#region Inicializace Footeru
        if (config && config.modalConfig.showFooter) {
            const modalWindowFooter: ModalWindowFooter = new ModalWindowFooter(null);
            this.container.appendChild(modalWindowFooter.container);
        }
        //#endregion Inicializace Footeru
    }
    //#endregion Constructors

    //#region IDisposable
    public dispose(): void {
        this.container.parentElement?.removeChild(this.container);
    }

    //#endregion IDisposable
}

/**
 * Reexport pro zpětnou kompatibilitu. Nově by se mělo importovat z ModalWindowInterfaces.
 */
export { IModalWindowConfiguration, ModalWindowType } from "./ModalWindowInterfaces";

export class ModalWindowHeader {
    //#region Events
    /**Udalost zavreni okna*/
    public close: Event<ModalWindowHeader, any> = new Event<ModalWindowHeader, any>();

    /**Udalost minimalizace okna*/
    public minimize: Event<ModalWindowHeader, any> = new Event<ModalWindowHeader, any>();

    /**Udalost maximalizace okna*/
    public maximize: Event<ModalWindowHeader, any> = new Event<ModalWindowHeader, any>();
    //#endregion Events

    //#region Fields
    public container: HTMLDivElement;
    private _closeButton: HTMLLabelElement;
    private _resizeButton: HTMLLabelElement;

    //#endregion Fields

    //#region Constructors
    constructor(_captionLocKey: string, showCloseButton: boolean, showMaxButton: boolean) {
        this.container = document.createElement("div");
        this.container.classList.add("Header");

        if (showCloseButton) {
            this._closeButton = document.createElement("label");
            this._closeButton.classList.add("closeButton");
            this._closeButton.title = "Close";
            this._closeButton.onclick = (() => {
                this.close.trigger(this, null);
            });

            this.container.appendChild(this._closeButton);
        }
        if (showMaxButton) {
            this._resizeButton = document.createElement("label");
            this._resizeButton.classList.add("maxButton");
            this._resizeButton.classList.add("resizeButton");
            this._resizeButton.title = "Maximize";
            this._resizeButton.onclick = (() => {
                const el = this._resizeButton;
                if (el.classList.contains("maxButton")) {
                    this.minimize.trigger(this, null);
                    el.classList.remove("maxButton");
                    el.classList.add("minButton");
                } else {
                    this.maximize.trigger(this, null);
                    el.classList.remove("minButton");
                    el.classList.add("maxButton");
                }
            });
            this.container.appendChild(this._resizeButton);
        }
    }

    //#endregion Constructors
}

export class ModalWindowFooter {
    public container: HTMLDivElement;

    //#region Constructors
    constructor(content: HTMLDivElement) {
        if (!content)
            this.container = document.createElement("div");
        else
            this.container = content;
        this.container.classList.add("Footer");
    }

    //#endregion Constructors
}
